module.exports = __webpack_public_path__ + "static/media/icon-piece-loa-09.bd7a14f6.png";